import React from 'react';
import './Footer.css';
import footer_logo from '../Assets/Frontend_Assets/logo_big.png';
import instagram_icon from '../Assets/Frontend_Assets/instagram_icon.png';
import pintester_icon from '../Assets/Frontend_Assets/pintester_icon.png';
import whatsapp_icon from '../Assets/Frontend_Assets/whatsapp_icon.png';

const footerLinks = [
    { id: 1, label: 'Company' },
    { id: 2, label: 'Products' },
    { id: 3, label: 'Offices' },
    { id: 4, label: 'About' },
    { id: 5, label: 'Contact' }
];

const socialIcons = [
    { id: 1, src: instagram_icon, alt: 'Instagram', ariaLabel: 'تابعنا على إنستجرام' },
    { id: 2, src: pintester_icon, alt: 'Pinterest', ariaLabel: 'تابعنا على بينتيريست' },
    { id: 3, src: whatsapp_icon, alt: 'WhatsApp', ariaLabel: 'تواصل معنا على واتساب' }
];

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer" role="contentinfo">
            <div className="footer-logo">
                <img src={footer_logo} alt="Shopper Logo" loading="lazy" />
                <p>STORE</p>
            </div>

            <nav aria-label="Footer Navigation">
                <ul className="footer-links">
                    {footerLinks.map((link) => (
                        <li key={link.id}>{link.label}</li>
                    ))}
                </ul>
            </nav>

            <div className="footer-social-icon" aria-label="Social Media Links">
                {socialIcons.map((icon) => (
                    <div key={icon.id} className="footer-icons-container">
                        <img src={icon.src} alt={icon.alt} loading="lazy" />
                    </div>
                ))}
            </div>

            <div className="footer-copyright">
                <hr />
                <p>Copyright © {currentYear} - All Rights Reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;